import {
  AdditionalRestriction,
  CoverageNeed,
  ProductCoverageName,
  ProductName,
} from "Store/akaAdvice/interfaces/CollectiveAdvice";

import { AdviceProductDetailsFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductDetails/FormElements/interfaces";
import { getDisabilityPaymentAfter3MonthsHint } from "Components/Features/CheckPrice/Products/Advice/ProductPrice/AdviceCards/DisabilityOneTimePaymentAdvisor/utils";
import { RadioButtonBoolean } from "Components/Form/RadioButton/RadioButtonBoolean";
import { getPayment } from "Store/akaAdvice/interfaces/getters";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { AkaAdvicePriceFormValues } from "../../../interfaces";

interface Props {
  adviceDetails: AdviceProductDetailsFormValues;
  formProps: FormikProps<AkaAdvicePriceFormValues>;
  need: CoverageNeed;
  recalculatePrice: (
    formValues: AkaAdvicePriceFormValues,
    specificProduct: ProductName,
  ) => void;
  adviceCard: any;
  lang: string;
}

export const DisabilityPaymentAfter3Months = ({
  adviceDetails,
  formProps,
  need,
  recalculatePrice,
  adviceCard,
  lang,
}: Props): React.ReactElement | null => {
  const payment = getPayment(need, ProductCoverageName.DISABILITY_FLEX_PENSION);
  const eligibleForPaymentAfter3Months =
    payment.restrictions.additionalRestrictions.includes(
      AdditionalRestriction.ELIGIBLE_FOR_PAYMENT_AFTER_3_MONTHS,
    );

  if (!eligibleForPaymentAfter3Months) {
    return null;
  }

  return (
    <RadioButtonBoolean
      name="disabilityPaymentAfter3Months"
      id="disabilityPaymentAfter3Months"
      label={
        adviceCard.disabilityOneTimePayment.advisorTexts.waitingPeriod.label[
          lang
        ]
      }
      hint={getDisabilityPaymentAfter3MonthsHint(
        eligibleForPaymentAfter3Months,
        adviceDetails,
        adviceCard.disabilityOneTimePayment,
        lang,
      )}
      direction="vertical"
      noLabel={
        adviceCard.disabilityOneTimePayment.advisorTexts.waitingPeriod
          .paymentAfter12Months[lang]
      }
      yesLabel={
        adviceCard.disabilityOneTimePayment.advisorTexts.waitingPeriod
          .paymentAfter3Months[lang]
      }
      error={getError("disabilityPaymentAfter3Months", formProps)}
      onChange={(option) => {
        recalculatePrice(
          {
            ...formProps.values,
            disabilityPaymentAfter3Months: option.value,
          },
          INSURANCE_NAME_VALUE.DISABILITY_FLEX,
        );
      }}
    />
  );
};
